// extracted by mini-css-extract-plugin
var _1 = "PriceSummary_bold__cPbPd";
var _2 = "PriceSummary_itemPrice__ACtuq";
var _3 = "PriceSummary_itemPriceDivider__80wfc";
var _4 = "PriceSummary_priceHeadline__VcwhS";
var _5 = "PriceSummary_pricePlanSummary__obM7T";
var _6 = "PriceSummary_pricesPlanDetail__avH7g";
export { _1 as "bold", _2 as "itemPrice", _3 as "itemPriceDivider", _4 as "priceHeadline", _5 as "pricePlanSummary", _6 as "pricesPlanDetail" }
